var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12326_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 3.3332H3.33329C2.89127 3.3332 2.46734 3.50879 2.15478 3.82135C1.84222 4.13391 1.66663 4.55784 1.66663 4.99986V16.6665C1.66663 17.1086 1.84222 17.5325 2.15478 17.845C2.46734 18.1576 2.89127 18.3332 3.33329 18.3332H15C15.442 18.3332 15.8659 18.1576 16.1785 17.845C16.491 17.5325 16.6666 17.1086 16.6666 16.6665V10.8332M15.4166 2.0832C15.7481 1.75168 16.1978 1.56543 16.6666 1.56543C17.1355 1.56543 17.5851 1.75168 17.9166 2.0832C18.2481 2.41472 18.4344 2.86436 18.4344 3.3332C18.4344 3.80204 18.2481 4.25168 17.9166 4.5832L9.99996 12.4999L6.66663 13.3332L7.49996 9.99986L15.4166 2.0832Z",
    stroke: "#438BFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12326_750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/editNew.80e6865d846796373ae1ce4502ca6556.svg";
export { ForwardRef as ReactComponent };